import isDate from 'lodash/isDate';
import isNaN from 'lodash/isNaN';
import isNumber from 'lodash/isNumber';

export const formatNumber = (
    locale: string,
    options: Intl.NumberFormatOptions,
    value: number
) => {
    if (isNumber(value)) {
        try {
            return new Intl.NumberFormat(locale, options).format(value);
        } catch (e) {
            console.log(e);
            return value;
        }
    }
    
    return value;
};

export const formatDateTime = (
    locale: string,
    options: Intl.DateTimeFormatOptions,
    value: number
) => {
    const date = new Date(value);
    const isValidDate = isDate(date) && !isNaN(date.getTime());

    if (isValidDate) {
        try {
            return new Intl.DateTimeFormat(locale, options).format(date);
        } catch (e) {
            console.log(e);
            return value;
        }
    }
    
    return value;
};

const formatter = (
    type: 'number' | 'currency' | 'date',
    locale: string,
    currency: string,
    options: Intl.NumberFormatOptions | Intl.DateTimeFormatOptions,
    value: number
) => {

    if (type === 'number') {
        return formatNumber(locale, options, value);
    }

    if (type === 'currency') {
        (options as Intl.NumberFormatOptions).currency = currency;
        return formatNumber(locale, options, value);
    }

    if (type === 'date') {
        return formatDateTime(locale, options, value);
    }

    return value;
};

export default formatter;


// WEBPACK FOOTER //
// ./src/Components/formatter.tsx